import React from "react";
import { Check } from "lucide-react";

/** Horizontal progress stepper for the Resume Builder Guided Wizard.
 * Clicking any step tab jumps straight there (no forced linear lock —
 * users can freely revisit earlier steps, matching FlowCV-style builders). */
export default function WizardStepper({ steps, currentStep, onStepClick }) {
  return (
    <div className="flex items-center w-full" data-testid="resume-wizard-stepper">
      {steps.map((s, idx) => {
        const isActive = s.id === currentStep;
        const isDone = s.id < currentStep;
        return (
          <React.Fragment key={s.id}>
            <button
              type="button"
              onClick={() => onStepClick(s.id)}
              data-testid={`resume-wizard-step-tab-${s.id}`}
              className="flex flex-col items-center gap-1.5 group shrink-0"
            >
              <span
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-colors ${
                  isActive ? "bg-indigo-500 text-white ring-4 ring-indigo-500/25" :
                  isDone ? "bg-emerald-500 text-white" : "bg-white/10 text-slate-400 group-hover:bg-white/15"
                }`}
              >
                {isDone ? <Check className="w-4 h-4" /> : s.id}
              </span>
              <span className={`text-[11px] font-semibold whitespace-nowrap ${isActive ? "text-white" : "text-slate-500 group-hover:text-slate-300"}`}>
                {s.label}
              </span>
            </button>
            {idx < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-1 -mt-5 transition-colors ${s.id < currentStep ? "bg-emerald-500" : "bg-white/10"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
